// extracted by extract-css-chunks-webpack-plugin
module.exports = {"navigationItem":"_2HRdo","navigationItemText":"_2toPO","navigationItemTextActive":"_3W-vY"};